import { IEntity } from './IEntity';

export interface IKeyValue extends IEntity {
	key: string;

	value: string;

	/**
	 * Number of minutes before a value is considered to be expired.
	 * Set to 0 to not expire.
	 */
	expiry: number;

	/**
	 * JSON-compatible structured value. PostgREST returns this as the parsed
	 * JSON value rather than as a serialized string.
	 */
	value_json: unknown;
}

export const resourceNameKeyValues = `keyvalue`;
